import * as React from "react";
import type { VariantProps } from "class-variance-authority";
import {
  Clock,
  CheckCircle,
  AlertCircle,
  XCircle,
  Loader2,
  type LucideIcon,
} from "lucide-react";

import { cn } from "../../lib/utils";
import { statusBadgeVariants } from "./status-badge-variants";

const statusIcons: Record<string, LucideIcon> = {
  default: Clock,
  success: CheckCircle,
  warning: AlertCircle,
  error: XCircle,
  info: AlertCircle,
  pending: Loader2,
};

export interface StatusBadgeProps
  extends
    React.HTMLAttributes<HTMLSpanElement>,
    VariantProps<typeof statusBadgeVariants> {
  icon?: LucideIcon;
  animate?: boolean;
  hideIcon?: boolean;
}

const StatusBadge = React.forwardRef<HTMLSpanElement, StatusBadgeProps>(
  (
    {
      className,
      variant = "default",
      size,
      icon,
      animate = false,
      hideIcon = false,
      children,
      ...props
    },
    ref,
  ) => {
    const IconComponent = icon || statusIcons[variant || "default"];
    const iconSize = size === "sm" ? 10 : size === "lg" ? 14 : 12;

    return (
      <span
        ref={ref}
        className={cn(statusBadgeVariants({ variant, size, className }))}
        {...props}
      >
        {!hideIcon && IconComponent && (
          <IconComponent
            size={iconSize}
            className={cn(animate && "animate-spin")}
          />
        )}
        {children}
      </span>
    );
  },
);
StatusBadge.displayName = "StatusBadge";

export { StatusBadge };
